export default __webpack_public_path__ + "static/media/momo02.a511b055.png";